import { useState } from "react"
import contactImg from "../assets/contact.jpg"

const WEB3FORMS_ACCESS_KEY = "b2123141-46d9-479a-a30a-24d5f9ff5c89"

const initialFormData = {
  fullName: "",
  organization: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  botcheck: "",
}

export default function GetInTouch() {
  const [formData, setFormData] = useState(initialFormData)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formStatus, setFormStatus] = useState({
    type: "",
    message: "",
  })

  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"

  const inputClass =
    "h-12 w-full rounded-md bg-gray-200 px-4 text-sm outline-none transition focus:bg-white focus:ring-2 focus:ring-[#ed860f]/25"

  const handleChange = (event) => {
    const { name, value } = event.target

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (formData.botcheck) return

    if (
      !formData.fullName.trim() ||
      !formData.organization.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      setFormStatus({
        type: "error",
        message: "Please fill all required fields.",
      })
      return
    }

    setIsSubmitting(true)
    setFormStatus({ type: "", message: "" })

    const payload = {
      access_key: WEB3FORMS_ACCESS_KEY,
      from_name: formData.fullName,
      subject: formData.subject.trim() || "New Get In Touch Form Submission",
      name: formData.fullName,
      organization: formData.organization,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      source: "Get In Touch Section",
    }

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      })

      const result = await response.json()

      if (!result.success) {
        throw new Error(result.message || "Message failed. Please try again.")
      }

      setFormData(initialFormData)
      setFormStatus({
        type: "success",
        message: "Message sent successfully. We will contact you soon.",
      })
    } catch (error) {
      setFormStatus({
        type: "error",
        message: error.message || "Something went wrong. Please try again.",
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="bg-white py-16 sm:py-20 lg:py-24">
      <div className={`${containerClass} grid gap-10 lg:grid-cols-2 lg:gap-14`}>
        <div>
          <h2 className="mb-5 text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
            Get In Touch
          </h2>

          <p className="mb-8 text-sm text-gray-600 sm:text-[15px]">
            Reach out to learn more about our smart monitoring solutions.
          </p>

          <div className="overflow-hidden rounded-xl">
            <img
              src={contactImg}
              alt="Contact"
              className="h-[300px] w-full object-cover object-center sm:h-[380px] lg:h-[430px]"
            />
          </div>
        </div>

        <form className="grid gap-5" onSubmit={handleSubmit}>
          <input
            type="checkbox"
            name="botcheck"
            value={formData.botcheck}
            onChange={handleChange}
            className="hidden"
            tabIndex="-1"
            autoComplete="off"
          />

          <div className="grid gap-5 sm:grid-cols-2">
            <div>
              <label className="mb-2 block text-sm font-semibold text-black">
                Full Name*
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className={inputClass}
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-semibold text-black">
                Organization*
              </label>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                className={inputClass}
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-semibold text-black">
                Email Address*
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={inputClass}
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-semibold text-black">
                Phone Number*
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className={inputClass}
                required
              />
            </div>
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-black">
              Subject
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={inputClass}
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-black">
              Message*
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="h-36 w-full resize-none rounded-md bg-gray-200 p-4 text-sm outline-none transition focus:bg-white focus:ring-2 focus:ring-[#ed860f]/25 lg:h-40"
              required
            />
          </div>

          {formStatus.message && (
            <p
              className={`rounded-md px-4 py-3 text-sm font-medium ${
                formStatus.type === "success"
                  ? "bg-green-50 text-green-700"
                  : "bg-red-50 text-red-700"
              }`}
            >
              {formStatus.message}
            </p>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="h-12 rounded-md bg-[#ed860f] text-sm font-medium text-white transition hover:bg-[#d9780d] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isSubmitting ? "Sending..." : "Send message"}
          </button>
        </form>
      </div>
    </section>
  )
}